<script>import FoldContainer from "./FoldContainer.svelte";
export let name;
export let label;
export let icon;
export let open = false;
</script>

<FoldContainer {name} {open} crossSize={"100%"}>
  <span class="header" slot="header"
    ><span class={icon} /><span class="title">{label}</span></span
  >
  <div class="content" slot="content">
    <slot />
  </div>
</FoldContainer>

<style>
  span.header {
    padding: 0 1rem;
    cursor: pointer;
    color: var(--base-color-content-primary, #eceeec);
  }
  span.header span.title {
    vertical-align: top;

    /* base/typography/desktop/label/medium */
    font-family: Roboto;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.37143;
    letter-spacing: 1px;

    /*overrule the line-height set by token*/
    line-height: 3rem;
  }
  span.header > span[class^="glyph-"],
  span.header > span[class*=" glyph-"],
  span.header > span[class^="icon-"],
  span.header > span[class*=" icon-"] {
    margin-right: 0.75rem;
    font-size: 1.5rem;
    line-height: 3rem;
    display:inline-block;
    min-width:2ch;
  }
  div.content {
    margin: 1rem 0.75rem 1rem 0.5rem;
  }
</style>
